Vue.component('user-management', {
    template: templates.userManagement,
    data() {
      return {
        model: {
          users: {},
          user:{},
          edit: false,
          roles: [
            { value: 'admin', name: 'Admin' },
            { value: 'mod', name: 'Mod' },
            { value: 'streamer', name: 'Streamer' },
            { value: 'user', name: 'User' },
          ],
        }
      }
    },
    mounted() {
      const c = this;
      c.get();
    },
    methods: {
      get() {
        const c = this;
        let data = {};

        userManagementService.get()
        .then(function (response) {
         for (let d of response.data) {
            data[`${d.id}`] = d;
          }
          c.model.users = data;

        })
        .catch(function (error) {
          //console.log(error);
        });
      },
      edit(id) {
        const c = this;

        let data = c.model.users[`${id}`];
        if (id == c.model.user.id) {
          c.model.edit = false;
        } else {
          c.model.edit = true;
        }

        c.model.user = {
          id: id,
          email: data.twitchEmail,
          role: data.role
        }
      
      },
      reset() {
        const c = this;
        c.model.edit = false;
      
      },
      selectedRole(){
        const c = this;
      },
      add() {
        const c = this;
        c.model.edit = true;
      },
      save() {
        const c = this;
  
        const data = c.model.user;
        
        userManagementService.save(data)
          .then(function (response) {
            c.get();
            // if (data.id) {
            //   c.model.stores[`${data.id}`] = data;
            // } else {
            //   data.id = response.data.id;
            //   c.model.stores[`${data.id}`] = data;
            // }
  
            c.reset();
            
            utils.alert.success('Saved!');
            
          })
          .catch(function (error) {
            utils.alert.error('Failed to save.');
          });
      },
    }
  });